export default __webpack_public_path__ + "static/char-s-05-kr-0f7929545dc8c382da5602982e15b330.png";